import React from "react";
import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import * as axios from "axios";

// Init Sentry
// eslint-disable-next-line no-unused-vars
import Sentry from "./api/sentry";
import "./index.css";
import App from "./App";
import store from "./state/store";
import * as serviceWorker from "./serviceWorker";

/* Axios */
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt");
    if (token) {
      config.headers.jwtauth = `Bearer ${token}`;
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, response: { data = {} } = {}, message } = error || {};
    if (data) {
      const { error, status } = data;
      if (error === "Invalid token" || status === "Invalid Login") {
        localStorage.removeItem("jwt");
        window.onbeforeunload = null;
        window.location = "/register/login";
        return Promise.reject(data);
      }
    }
    if (response) return Promise.reject(response);
    if (message) return Promise.reject(message);
    return Promise.reject(error);
  }
);

// App entry
const container = document.getElementById("root")
const root = createRoot(container);
root.render(
  <Router basename="/register">
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
